<template>
  <article class="card" :class="{'van-hairline--bottom': !isReply, reply: isReply}">
    <header class="head" @click="$router.push(`/user/${comment.userId}`)">
      <img-lazy class="avatar" :src="comment.avatar | thumbnail(80, 80)"/>
      <p class="name">
        {{ comment.name }}
        <span v-if="parentComment && parentComment.parentId && isReply">回复{{ parentComment.name }}</span>
      </p>
    </header>
    <div class="main">
      <div class="content" v-html="comment.content"></div>
      <footer class="foot">
        <span class="time">{{ comment.createTime | formatTime }}</span>
        <span class="operate">
          <a class="action-reply" @click="openCommentBox" v-if="comment.children">回复</a>
          <a class="action-like" @click="likeComment">
            <i class="iconfont icon-zan" :class="{active: isLiked}"></i>{{ comment.like | nFormatter }}
          </a>
        </span>
      </footer>
      <div class="reply-list" v-if="comment.children">
        <card-comment v-for="item in comment.children" :comment="item" :parent-comment="comment" :key="item.id" @comment="commentEvent" @like="likeEvent"/>
      </div>
    </div>
  </article>
</template>

<script>
  import ImgLazy from '@/components/ImgLazy'
  import { likeComment, unlikeComment } from "../api/common"

  export default {  
    name: "card-comment",
    components: { ImgLazy },

    props: {
      comment: {
        type: Object,
        required: true
      },
      parentComment: Object,
    },

    data() {
      return {
        isCommentBoxShow: false,

      }
    },

    computed: {
      isReply() {
        return !!this.comment.parentId;
      },

      isLiked() {
        return this.comment.likeUserIds.includes(this.$store.state.userInfo.userId);
      }
    },

    methods: {
      likeEvent(id){
        this.$emit('like', id)
      },
      commentEvent(data){
        this.$emit('comment', data)
      },
      openCommentBox() {
        this.$emit('comment', this.comment.id)
      },

      async likeComment() {
        if (this.comment.likeUserIds.indexOf(this.$store.state.userInfo.userId) > -1) {
          this.$toast('已赞');
          return;
        }
        await likeComment(this.comment.id)

        this.$emit('like', this.comment.id)
        this.$toast('已赞')
      },

      async unlikeComment() {
        await unlikeComment(this.comment.id)

        this.$toast('已取消赞')
      },

      onCommented(data) {
        this.$toast('已回复')

        let { userId, name, avatar, } = this.$store.state.userInfo

        this.comment.children.push({
          ...data,
          userId,
          name,
          avatar,
          like: 0,
          likeUserIds: [],
          level: 0,
          createTime: new Date().toISOString().replace(/T/, ' ').replace(/\..+/, ''),
        })
      }
    }
  }
</script>

<style lang="less" scoped>
.card {
  background-color: #fff;
  padding: 10px 10px 5px 0;

  .head {
    display: flex;

    .avatar {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      margin-right: 10px;
    }
    .name {
      flex: 1;
      color: #626262;
      font-size: 14px;
    }
  }

  .main {
    padding-left: 50px;
    margin-top: -20px;
  }

  .content {
    font-size: 15px;
    line-height: 18px;
    color: #000;
    margin-bottom: 10px;
    /deep/ img {
      margin-bottom: -5px;
      zoom: .8;
    }
  }

  .foot {
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    color: #626262;
    margin-bottom: 5px;
  }

  .time {
  }

  .operate {
    font-size: 14px;
  }
}

.reply-list .card {
  background-color: #F4F8FB;
}

  .reply {
    .head {
      padding-left: 20px;
    }
    .avatar {
      width: 30px;
      height: 30px;
    }
    .main {
      padding-left: 70px;
      margin-bottom: 0;
    }

    /deep/.reply {
      .main {
        padding-left: 0;
      }


    }
  }

  .action-reply {
    margin-right: 20px;
  }
  .action-like .iconfont {
    font-size: 12px;
    margin-right: 3px;
  }
</style>